import React from "react";
import { Box, Typography, Button } from "@mui/material";
import logo from "../assets/images/bg3.png";

function Dashboard() {
  return (
    <Box sx={{ height: '100vh', display: "grid", justifyContent: "center", backgroundImage: `url(${logo})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      <Box>
        <Typography
          variant="h1"
          sx={{
            fontSize: '2.25rem', // text-4xl
            marginRight: '22rem', // mr-96
            width: '33%', // size-4/12
            marginTop: '12rem', // mt-48
            color: 'white',
          }}
        >
          Welcome to MixCodes Portal. Please use the menus above to get started
        </Typography>
      </Box>
    </Box>
  );
}

export default Dashboard;
